/* eslint-disable react-hooks/exhaustive-deps */
import * as React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useRecoilValue } from 'recoil';
import DynamicTable from '../DynamicTable';
import { TABLE_ALARM, TABLE_ALARM_LOG } from '../../Services/TableService';
import { tabsByPermission } from '.';
import TabComponent from '../TabComponent';
import { ITableFilter, setTableFilterAtom } from '../../store/recoil/TableState';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import OnlineHelp from '../OnlineHelp';

export default function AlarmLogs(): JSX.Element {
  const tableFilter = useRecoilValue<ITableFilter | null>(setTableFilterAtom);
  const tabs = React.useState(tabsByPermission([TABLE_ALARM, TABLE_ALARM_LOG], TABLE_ALARM_LOG))[0];
  const { formatMessage: f } = useIntl();
  const documentTitle = `${f({ id: 'tab.alarm/log' })} - ${f({ id: 'menu.alarms' })}`;
  useDocumentTitle(documentTitle);

  return (
    <div>
      <div className="col-12" style={{ display: '' }}>
        <div className="row section page-head">
          <h4>
            <FormattedMessage id="menu.alarms" />
            <OnlineHelp topic="alarms" />
          </h4>
        </div>
        <TabComponent tabs={tabs}>
          <div>
            <DynamicTable name={TABLE_ALARM_LOG} filter={tableFilter} mustClosed={true} />
          </div>
        </TabComponent>
      </div>
    </div>
  );
}
